import styled from 'styled-components'

interface Prop {
  yellow?: boolean
  medium?: boolean
  small?: boolean
}

export const Button = styled.button`
  border-radius: 20px;
  width: 139px;
  height: 56px;
  ${(props) =>
    props.small &&
    `
    width: 139px;
    height: 56px;
  `}
  ${(props) =>
    props.medium &&
    `
    width: 167.73px;
    height: 56px;
  `}
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-family: Inter;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  background-color: transparent;
  transition: all 0.3s ease;
  border: ${(props: Prop) => {
    if (props.yellow) return '2px solid #FFC600'
    return '2px solid #1C1D22'
  }};
  color: ${(props: Prop) => {
    if (props.yellow) return '#FFC600'
    return '#1C1D22'
  }};
  &:hover {
    color: #ffffff;
    background-color: ${(props: Prop) => {
      if (props.yellow) return '#FFC600'
      return '#1C1D22'
    }};
  }
  &&:disabled {
    background-color: transparent;
  }
  cursor: pointer;
  .icon {
    width: 24px;
  }
  &:hover .icon {
    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(13%)
      hue-rotate(237deg) brightness(104%) contrast(104%);
  }
  @keyframes load {
    to {
      transform: rotate(360deg);
    }
  }
  .loading-icon {
    max-width: 28px;
    max-height: 28px;
    animation: load 2s infinite linear;
  }
`
